//
// ReportDataLevel.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ReportDataLevel = {
    BASELINE:0,
    INTERACTIVE:1,
    NODATA:2,
    CUSTOM:3,
    OFFLINE:4
};
export default ReportDataLevel;
